import { FleekError } from './FleekError';

type FolderNotFoundErrorOptions = {
  folder: { id?: string; path?: string };
};

export class FolderNotFoundError extends FleekError<FolderNotFoundErrorOptions> {
  public name = 'FolderNotFoundError';

  toString = () => `Folder was not found.`;
}
